import Text from "../../../../design-system/primitives/components/Text/Text";
import type { SparkChatSource } from "../types";

/** Where in the Spark's material an answer comes from. */
export const Sources = ({ sources }: { sources: SparkChatSource[] }) => {
  if (sources.length === 0) return null;

  return (
    <Text variant="label-small" color="neutral-100">
      {`Aus dem Material: ${sources.map((s) => s.title).join(" · ")}`}
    </Text>
  );
};
